import axios from 'axios';

export function isCancel(e: unknown): boolean {
  return axios.isCancel(e);
}
